import { r } from "./apiBase";
import path from "./path";

export const api = {
  // auth0認証
  auth0: {
    // auth0 token save
    setToken: r(`POST ${path.auth0.setToken}`),

    // ユーザーの偽装 userCd save
    setUserCode: r(`POST ${path.auth0.setUserCode}`),

    // IF1046 remove redis
    removeRedis: r(`GET ${path.auth0.removeRedis}`),
  },

  // リサーチ情報 News情報 リサーチ情報_検索 関連記事
  report: {
    // リサーチ情報 News情報
    getList: r(`POST ${path.report.getList}`),

    // リサーチ情報_検索
    search: r(`POST ${path.report.search}`),

    // 関連記事
    related: r(`POST ${path.report.related}`),

    // レポートの詳細を取得するtags
    getTags: r(`GET ${path.report.getTags}`),

    // コンテンツ配信評価ボタン状態取得処理(TARp0001)
    getEvaluate: r(`GET ${path.report.getEvaluate}`, false),

    // コンテンツ配信評価ボタン状態登録処理(TARp0002)
    evaluate: r(`POST ${path.report.evaluate}`, false),
  },

  // 横断検索
  home: {
    // 横断検索 result list
    search: r(`POST ${path.home.search}`),

    // banner
    getbanners: r(`GET ${path.home.getbanners}`),
  },

  // マイページ
  mypage: {
    // マイページ list
    getList: r(`POST ${path.mypage.getList}`),
  },

  // タグ
  dictionary: {
    // リサーチ情報検索
    getTagList: r(`GET ${path.dictionary.getTagList}`),

    // リサーチ情報_検索タグ
    getTagFirstList: r(`GET ${path.dictionary.getTagFirstList}`),

    // 事例集
    getTagExampleList: r(`GET ${path.dictionary.getTagExampleList}`),

    // ライブラリー検索
    getTagLibraryList: r(`GET ${path.dictionary.getTagLibraryList}`),
  },

  // 画像の取得
  image: {
    // itemidによる画像のurl取得
    getByItemId: r(`GET ${path.image.getByItemId}`),

    // urlによる画像バイナリデータの取得
    getByKey: r(`GET ${path.image.getByKey}`, true, "blob"),
  },
  // ユーザ登録情報
  user: {
    // 共通ヘッダー情報取得処理
    getHeaderInfo: r(`GET ${path.user.getHeaderInfo}`, false),

    // ログイン日時更新処理
    getLoginInfo: r(`PUT ${path.user.getLoginInfo}`, false),

    // ログアウト処理
    logout: r(`GET ${path.user.logout}`, false),

    // 企業情報取得処理
    getCompanyInfo: r(`GET ${path.user.getCompanyInfo}`, false),

    // coreログアウト処理
    coreLogout: r(`GET ${path.user.coreLogout}`, false),

    // coreログイン処理
    coreLogin: r(`POST ${path.user.coreLogin}`, false),

    // 企業プロフィール更新有無取得処理
    getCompanyInfoModificationExistence: r(
      `GET ${path.user.getCompanyInfoModificationExistence}`,
      false
    ),

    // 規約同意取得処理(TASp0011)
    getAgreementStatus: r(`GET ${path.user.getAgreementStatus}`, false),

    // BM利用停止フラグ取得(TABp0034)
    getBmInfo: r(`GET ${path.user.getBmInfo}`, false),

    // アカウント権限情報取得処理(TASp0013)
    getMenuAuthorityInfo: r(`GET ${path.user.getMenuAuthorityInfo}`, false),

    // 契約とお支払い初期表示処理(TAPp0001)
    getContracts: r(`GET ${path.user.getContracts}`, false),

    // ユーザープロフィール初期表示処理(TACp0006)
    getUserProfileInfo: r(`GET ${path.user.getUserProfileInfo}`, false),

    // マスター権限アカウント有無確認処理(TACp0018)
    getAccountMasterExist: r(`GET ${path.user.getAccountMasterExist}`, false),

    // メニューバッジ取得処理(TASp0006)
    getMenuBadgeInfo: r(`GET ${path.user.getMenuBadgeInfo}`, false),

    // お知らせバッジ取得処理(TASp0007)
    getInformationBadgeInfo: r(
      `GET ${path.user.getInformationBadgeInfo}`,
      false
    ),

    // ユーザ存在チェック
    checkUserExist: r(`GET ${path.user.checkUserExist}`, false),

    // 入会バージョン情報取得処理(TASp0016)
    getCustomersVersion: r(`GET ${path.user.getCustomersVersion}`, false),
  },

  library: {
    // 事例集list
    getExampleList: r(`POST ${path.library.getExampleList}`),

    // 画面カテゴリーを取得する
    getPdfCategory: r(`GET ${path.library.getPdfCategory}`),

    // トレンド解説
    getTrendList: r(`GET ${path.library.getTrendList}`),

    // マクロ経済メモ
    getNriReportList: r(`GET ${path.library.getNriReportList}`),

    // 税務・事業承継
    getTaxaList: r(`GET ${path.library.getTaxaList}`),

    // IPO(年月以外のPDFデータ)
    getIpoList: r(`GET ${path.library.getIpoList}`),

    // IPO(年のPDFデータ)
    getIpoYearList: r(`GET ${path.library.getIpoYearList}`),

    // IPO(月のPDFデータ)
    getIpoMonthList: r(`GET ${path.library.getIpoMonthList}`),

    // M&A
    getMAList: r(`GET ${path.library.getMAList}`),

    // 財務分析のヒント
    getFinancialList: r(`GET ${path.library.getFinancialList}`),
    
    // 業界レポート
    getBusinessReportList: r(`GET ${path.library.getBusinessReportList}`),

    // ライブラリー検索
    search: r(`POST ${path.library.search}`),

    // 関連記事
    related: r(`POST ${path.library.related}`),

    // PDF、外部リンク開く
    pdfLinkAccess: r(`POST ${path.library.pdfLinkAccess}`),

    // libraryの詳細を取得するtags
    getTags: r(`GET ${path.library.getTags}`),
  },

  pickup: {
    // ピックアップ list
    getList: r(`POST ${path.pickup.getList}`),
  },

  faq: {
    // よくある質問list
    getList: r(`GET ${path.faq.getList}`),
  },

  // lp
  lp: {
    // よくある質問list
    getQAList: r(`GET ${path.lp.getQAList}`),

    // お知らせlist
    getNewsReleaseList: r(`GET ${path.lp.getNewsReleaseList}`),
  },

  // agreement
  agreement: {
    // 利用規約同意
    getNoLoginProtocal: r(`GET ${path.agreement.getNoLoginProtocal}`),

    // 利用規約変更時
    getLoginProtocal: r(`GET ${path.agreement.getLoginProtocal}`),

    // フッターの利用規約
    getPublishProtocal: r(`GET ${path.agreement.getPublishProtocal}`),

    // 利用規約変更時更新
    updateLoginProtocal: r(`POST ${path.agreement.updateLoginProtocal}`),

    // 課金-ADD-START
    // ビジネスマッチング支援プラン利用規約情報取得処理（IF1049）
    getLoginPaymentProtocal: r(`GET ${path.agreement.getLoginPaymentProtocal}`),

    // ビジネスマッチング支援プラン利用規約情報変更時（既存顧客）情報取得処理（IF1050）
    getLoginUpdatePaymentProtocal: r(
      `GET ${path.agreement.getLoginUpdatePaymentProtocal}`
    ),

    // ビジネスマッチング支援プラン利用規約情報取得処理変更時の同意情報セット処理（IF1051）
    updateLoginPaymentProtocal: r(
      `POST ${path.agreement.updateLoginPaymentProtocal}`
    ),
    // 課金-ADD-END

    // プライバシーポリシー同意
    getNoLoginPrivacyPolicy: r(`GET ${path.agreement.getNoLoginPrivacyPolicy}`),

    // プライバシーポリシー変更時
    getLoginPrivacyPolicy: r(`GET ${path.agreement.getLoginPrivacyPolicy}`),

    // プライバシーポリシーの利用規約
    getPublishPrivacyPolicy: r(`GET ${path.agreement.getPublishPrivacyPolicy}`),

    // プライバシーポリシー変更時
    updateLoginPrivacyPolicy: r(
      `POST ${path.agreement.updateLoginPrivacyPolicy}`
    ),

    // 問合せ機能について同意
    getNoLoginInquiry: r(`GET ${path.agreement.getNoLoginInquiry}`),

    // 問合せ機能について変更時
    getLoginInquiry: r(`GET ${path.agreement.getLoginInquiry}`),

    // 問合せ機能についての利用規約
    getPublishInquiry: r(`GET ${path.agreement.getPublishInquiry}`),

    // 問合せ機能について変更時
    updateLoginInquiry: r(`POST ${path.agreement.updateLoginInquiry}`),
  },

  // 共通
  common: {
    getTime: r(`GET ${path.common.getTime}`),
  },

  // お知らせ
  information: {
    // お知らせ一覧初期表示処理(TASp0008)
    getList: r(`GET ${path.information.getList}`, false),

    // お知らせ詳細初期表示処理(TASp0009)
    exist: (informationId) =>
      r(`GET ${path.information.exist}${informationId}`, false),

    // お知らせ既読登録処理(TASp0010)
    read: (informationId) =>
      r(`POST ${path.information.read}${informationId}`, false),

    // お知らせ詳細
    getDetail: r(`POST ${path.information.getDetail}`),
  },
};
